import { Validator } from '@vista-digital/validator';
import { PromotedTagAlignment } from '../../../../subcomponents/promoted-tag';
/**
 * Default configuration options for the Film Promoted Tag component.
 */
export const defaultFilmPromotedTagConfig = {
    alignment: PromotedTagAlignment.Center
};
export const filmPromotedTagConfigValidatorSchema = {
    alignment: Validator.oneOf(Object.values(PromotedTagAlignment))
};
export const filmPromotedTagConfigValidator = Validator.object(filmPromotedTagConfigValidatorSchema);
